<script lang="ts">
  import { UiKeys } from '@voicedojo/backend-types';
  import { t } from '$lib/i18n';
  import { accountMove } from '$lib/stores/accountMove';
  import { Notice } from '$lib/ui';
  import { regionName } from '$lib/utils/formatting/region';
</script>

{#if $accountMove}
  <Notice tone="warning" role="status" class="offline-banner no-print" data-testid="account-move-banner">
    {$accountMove.target
      ? t(UiKeys.HomeMove.Banner, { Region: regionName($accountMove.target) })
      : t(UiKeys.HomeMove.BannerUnknownRegion)}
  </Notice>
{/if}
